import React, { useEffect, useState } from 'react';
import * as Yup from "yup";
import Breadcrumbs from '../../components/BreadCrumbs';
import { toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import { Form, Formik } from 'formik';
import Button from '../../components/buttons/Button';
import InputField from '../../components/inputFields/InputField';
import FormikDropdown from '../../components/inputFields/FormikDropDown';
import ImagePicker from '../../components/inputFields/ImagePicker';
import { patchTemplate, postTemplate } from '../../services/notification_campaign';

function NotificationCampaignForm() {
    const location = useLocation();
    const [rowData, setRowData] = useState(null);
    const navigate = useNavigate();
    const [image, setShopLogo] = useState(null);

    const handleDiscardChanges = (resetForm) => {
        resetForm();
        navigate(-1);
    };

    const handleimageSelect = (file) => {
        setShopLogo(file);
    };

    const handleFormSubmit = async (values, { setSubmitting }) => {
        const formData = new FormData();
        if (image && typeof image === "object") {
            formData.append("image", image);
        }

        if (rowData && rowData.image && image === null) {
            formData.append("image", null);
        }

        formData.append('title', values.title);
        formData.append('body', values.body);
        formData.append('category', values.category);
        formData.append('redirect_screen', values.redirect_screen);

        try {
            const response = rowData ? await patchTemplate({
                data: formData,
                id: rowData.id,
            }) : await postTemplate(formData);

            if (response?.status === 200 || response?.status === 201) {
                toast.success(rowData ? "Template updated successfully" : "Template genrated successfully!");
                navigate(-1);
            } else {
                let errors = "Opps! Something went wrong, please try again.";
                toast.error(errors);
            }
        } catch (error) {
            let errors =
                error?.response?.data?.error ||
                "Opps! Something went wrong, please try again.";
            toast.error(errors);
        }
        setSubmitting(false);
    };

    useEffect(() => {
        if (location.state) {
            setRowData(location.state);
            if (location.state.image) {
                setShopLogo(location.state.image);
            }
        }
    }, [location]);

    return (<>
        <Breadcrumbs items={[
            { name: 'Home', link: '/dashboard' },
            { name: 'Notification Campaign', link: (-1) },
            { name: 'Add Template' },
        ]} />
        <div className="mt-8">
            <Formik
                initialValues={rowData || {
                    title: "",
                    body: "",
                    redirect_screen: "",
                    category: "general",
                }}
                validationSchema={Yup.object({
                    category: Yup.string().required("Category is required"),
                    title: Yup.string().required("Title is required"),
                    body: Yup.string().required("Message is required"),
                })}
                onSubmit={handleFormSubmit}
                enableReinitialize
            >
                {({ isSubmitting, resetForm }) => (
                    <Form>
                        <div className="border border-gray-300 mt-5 p-4 rounded-lg bg-gray-100 flex flex-col md:flex-row gap-4">
                            <div className="flex flex-col w-full">
                                <div className="grid gap-2 grid-cols-1 md:grid-cols-2">
                                    <FormikDropdown
                                        label="Category"
                                        name="category"
                                        placeholder="Redirection"
                                        required
                                        options={[
                                            {
                                                label: "General",
                                                value: "general",
                                            },
                                            {
                                                label: "Bazaar (Mobile)",
                                                value: "bazaar_mobile",
                                            },
                                            {
                                                label: "Devices",
                                                value: "devices",
                                            },
                                            {
                                                label: "Expense",
                                                value: "expense",
                                            },
                                            {
                                                label: "Satellite",
                                                value: "satellite",
                                            },
                                            {
                                                label: "Community (Forum & Post)",
                                                value: "community",
                                            },
                                            {
                                                label: "Farm & Commodity",
                                                value: "farm_commodity",
                                            },
                                            {
                                                label: "Mandi Rate",
                                                value: "mandi_rate",
                                            },
                                            {
                                                label: "Diseases & Precautions",
                                                value: "diseases_precautions",
                                            },
                                            {
                                                label: "NPK Calculator",
                                                value: "npk_calculator",
                                            },
                                            {
                                                label: "Dukaan App",
                                                value: "dukaan_app",
                                            },
                                        ]}
                                        needSearch
                                    />
                                    <FormikDropdown
                                        label="Redirection Screen"
                                        name="redirect_screen"
                                        placeholder="Redirection"
                                        options={[
                                            {
                                                label: "Bazaar",
                                                value: "bazaar",
                                            },
                                            {
                                                label: "Diseases & Precautions",
                                                value: "precaution",
                                            },
                                            {
                                                label: "NPK Calculator",
                                                value: "calculator",
                                            },
                                            {
                                                label: "Devices",
                                                value: "devices",
                                            },
                                            {
                                                label: "Expense",
                                                value: "expense",
                                            },
                                            {
                                                label: "Satellite",
                                                value: "satellite",
                                            },
                                            {
                                                label: "Practice Commodity",
                                                value: "practice",
                                            },
                                            {
                                                label: "Community",
                                                value: "community",
                                            },
                                            {
                                                label: "Forum",
                                                value: "forum",
                                            },
                                            {
                                                label: "Farm & Commodity",
                                                value: "farm",
                                            },
                                        ]}
                                        needSearch
                                    />
                                </div>
                                <InputField
                                    label="Title"
                                    name="title"
                                    type="text"
                                    placeholder="Title Of Notification"
                                    required
                                />
                                <div className="flex-1">
                                    <InputField
                                        label="Message"
                                        name="body"
                                        type="text"
                                        placeholder="Write your body here......"
                                        required
                                    />
                                </div>
                                <div className="flex gap-2 flex-col md:flex-row">
                                    <div className="h-48 aspect-video mx-2">
                                        <ImagePicker
                                            preloadedImage={image}
                                            placeholder='Select Image (16:9)'
                                            onImageSelect={handleimageSelect}
                                        />
                                    </div>
                                    {
                                        image && (
                                            <div className="h-48 text-red-700 font-bold cursor-pointer" onClick={() => setShopLogo(null)}>
                                                Remove Image
                                            </div>
                                        )
                                    }
                                </div>
                                <div className="py-5 flex justify-end gap-6">
                                    <div>
                                        <Button
                                            type="button"
                                            className="text-primary bg-white hover:bg-white-dark font-sm rounded-lg text-lg w-full px-8 py-1.5 text-center border border-primary"
                                            onClick={() => handleDiscardChanges(resetForm)}
                                            disabled={isSubmitting}
                                        >
                                            Discard Changes
                                        </Button>
                                    </div>
                                    <div>
                                        <Button
                                            type="submit"
                                            className="text-white bg-primary hover:bg-primary-dark font-sm rounded-lg text-lg w-full px-8 py-1.5 text-center"
                                            disabled={isSubmitting}
                                        >
                                            {isSubmitting ? "Sending..." : "Save"}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    </>);
}

export default NotificationCampaignForm;
